@let currentLabel = label();
@let currentOptions = options();
@let currentLayout = layout();

<div class="mb-4">
  @if (currentLabel) {
    <label class="block text-[14px] font-medium text-gray-700 mb-1 break-words">{{
      currentLabel
    }}</label>
  }
  <div
    class="flex"
    [class.flex-col]="currentLayout === 'vertical'"
    [class.space-y-2]="currentLayout === 'vertical'"
    [class.flex-row]="currentLayout === 'horizontal'"
    [class.space-x-4]="currentLayout === 'horizontal'"
    [class.items-center]="currentLayout === 'horizontal'"
  >
    @for (option of currentOptions; track option.value) {
      <div class="flex items-center gap-2">
        <input
          type="radio"
          [id]="effectiveName() + '-' + option.value"
          [name]="effectiveName()"
          [value]="option.value"
          [checked]="_value() === option.value"
          [disabled]="isDisabled"
          (change)="selectOption(option.value)"
          (blur)="onTouched()"
          class="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
        />
        <label
          [for]="effectiveName() + '-' + option.value"
          class="block text-[14px] text-gray-900 cursor-pointer"
        >
          {{ option.display }}
        </label>
        @if (option.tooltip) {
          <div class="custom-tooltip-container rounded-full bg-primary_container p-2">
            <i class="fas fa-question text-primary_dark text-[12px] cursor-help"></i>
            <div class="custom-tooltip-text">
              {{ option.tooltip | translate }}
            </div>
          </div>
        }
      </div>
    }
  </div>
  <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
</div>
